import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'oauth.index',
    component: () => import('@/views/oauth')
  },
  {
    path: '/binding',
    name: 'employee.binding',
    component: () => import('@/views/oauth/bind')
  },
  {
    path: '/error/400',
    name: 'error.400',
    component: () => import('@/views/error/400')
  },
  {
    path: '/error/403',
    name: 'error.403',
    component: () => import('@/views/error/403')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

export default router
